import type { ItemsPageByColumnValuesQuery } from "@mondaydotcomorg/api";
import {
	ALL_MONDAY_SCHEMAS,
	MONDAY_PAGINATED_PARAMS_DEF,
	MONDAY_PAGINATED_PARAMS_USE,
	type MONDAY_TYPES,
} from "@onesolution/monday";
import { gql } from "graphql-request";
import { formatPaginatedResult } from "../format";
import { requestAndFormat } from "../utils";

export const itemPageByValuesQuery = <T, Y = MONDAY_TYPES["base"] & T>(params: {
	boardId: string;
	columnIds: string[];
	filter: ItemsPageByColumnValuesQuery[];
	cursor?: string;
	limit?: number;
}) =>
	requestAndFormat(
		{
			defaultParams: {},
			gql: gql`
        query GetItemPageByValues(
            $boardId: ID!,
            $columnIds: [String!]!,
            ${MONDAY_PAGINATED_PARAMS_DEF(params.cursor, "$filter: [ItemsPageByColumnValuesQuery!]!")}
            
        ) {
            items_page_by_column_values(
                board_id: $boardId
                ${MONDAY_PAGINATED_PARAMS_USE(params.cursor, "columns: $filter")}
            ) {
                cursor
                items {
                    id
                    name
                    column_values(ids: $columnIds) {
                        ${ALL_MONDAY_SCHEMAS}

                        ... on BoardRelationValue {
                            display_value
                        }
                    }
                }
            }
        }
        `,
			resultKey: "items_page_by_column_values.items",
			additionalFormatting: formatPaginatedResult<Y>(
				"items_page_by_column_values.cursor",
			),
			outType: {} as { cursor: string; items: Y[] },
		},
		params,
	);
